import { useContext } from 'react'
import { useLocalStorage } from '@rehooks/local-storage'
import { ConnectedUser } from '@ucc/admin-global-state'

import { ConnectedUserContext } from 'components'
import config from 'config'
import { useUserHasAdminRoles } from 'hooks'

const useUserIsBillingAdminOnly = () => {
  const connectedUser = useContext(ConnectedUserContext)
  const [iAmInfos] = useLocalStorage<ConnectedUser>(config.I_AM_TOKEN_KEY)
  const userHasAdminRoles = useUserHasAdminRoles()
  const currentUser = connectedUser ? connectedUser : iAmInfos

  return (selectedAccountKey?: any): boolean => {
    if (selectedAccountKey) {
      return (
        userHasAdminRoles('BILLING_ADMIN', selectedAccountKey) &&
        currentUser?.accounts?.find((account) => account.key === selectedAccountKey)?.adminRoles?.length === 1
      )
    }
    return false
  }
}

export default useUserIsBillingAdminOnly
